// extracted by mini-css-extract-plugin
export default {"tabsDesktop":"Tab_tabsDesktop__ARNCk","tabDesktop":"Tab_tabDesktop__b0pGy","tabID":"Tab_tabID__UBNaB","tabsMobile":"Tab_tabsMobile__mlZ7k","tabMobile":"Tab_tabMobile__NS7kV"};